/**
 * AddonButton component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Props from '@shared/types/props/pressable';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled addon button.
 */
const AddonButton = styled.button<Props>`
  width: fit-content;
  height: ${71 * Screen.widthRatio}px;
  padding: 0 ${30 * Screen.widthRatio}px;
  border-radius: ${50 * Screen.widthRatio}px;
  background: ${(props) =>
    props.focused || !props.canClick ? Colors['light'] : 'transparent'};
  opacity: ${(props) => (!props.canClick ? '0.3' : '1')};
  border: ${(props) =>
    props.focused ? 'none' : `2px solid ${Colors['light']};`};
  color: ${(props) =>
    props.focused || !props.canClick ? Colors['dark'] : Colors['light']};
  cursor: pointer;
  margin-right: ${20 * Screen.widthRatio}px;
  font-size: ${30 * Screen.widthRatio}px;
  font-family: ${Fonts['bold']};
  &:hover {
    background: ${Colors['light']};
    color: ${Colors['dark']};
  }
`;

export default AddonButton;
